import { isPageLocalized } from './localizedPages';

/**
 * Locales that actually return 200 for this path (avoids hreflang to redirect/4xx).
 * Non-localized and non-LOCALIZED_PAGES paths only have defaultLocale; others have all locales.
 */
export function getEffectiveHreflangLocales(
	cleanPath: string,
	isNonLocalized: boolean,
	locales: readonly string[] | string[],
	defaultLocale: string,
): readonly string[] {
	if (isNonLocalized || !isPageLocalized(cleanPath)) {
		return [defaultLocale];
	}
	return locales;
}
